import React from 'react';
import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import { connect } from 'react-redux';
import get from 'lodash.get';
import ExtraUserInformationFormModal from './ExtraUserInformationFormModal';
import styles from './ExtraUserInformation.css';
import NorthWestAdditionalInformationFields from './NorthWestAdditionalInformationFields';

const NorthWestExtraInformation = ({ ...props }) => (<ExtraUserInformationFormModal
    title="Welcome to Northeast Wisconsin Technical College - Admissions!"
    subtitle="Please provide some additional information below to continue."
    {...props}
>
    <NorthWestAdditionalInformationFields />
    <p className={styles.info}>
        {'By creating a user account, I give consent to be contacted by mail, email and telephone (including auto-dialed, prerecorded and/or text messaging) to the designated number and contact information I have provided to receive information. I also give consent to share my information and results with counselors. Standard messaging and data rates may apply based on the plan you have with your mobile carrier.'}
    </p>
</ExtraUserInformationFormModal>);

export default compose(
    connect(({ me, auth }) => ({
        show: (me && (!me.expectedGraduationYear
            || !me.dateOfBirth
            || !me.mobilePhone
            || !me.streetAddress
            || !me.state
        ) && Number(auth.level) === 5),
        initialValues: {
            dateOfBirth: get(me, 'dateOfBirth'),
            mobilePhone: get(me, 'mobilePhone'),
            expectedGraduationYear: get(me, 'expectedGraduationYear'),
            currentInstitution: get(me, 'currentInstitution'),
            streetAddress: get(me, 'streetAddress'),
            unit: get(me, 'unit'),
            city: get(me, 'city'),
            state: get(me, 'state'),
        },
    })),
    branch(
        ({ show }) => !show,
        renderNothing,
    ),
)(NorthWestExtraInformation);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/NorthWestExtraInformation.js